<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.codigo }} - {{ $t('name') }} : {{ item.nome }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
            <DownloadButton />
          </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						@click="downloadCSVCategoriaFitossanidade()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="tableData"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 0.5rem; flex-direction: column">
					<InputText
						:label="$t('name') + '*'"
						:value="model.nome"
						:disabled="desabilitarCamposDoFormularioParaCategoriasPadrao"
						@input="model.nome = $event.toUpperCase()"
					/>
					<InputText
						v-model="model.descricao"
						:label="$t('description')"
					/>

					<label>{{ $t('color') }}*</label>
					<div class="flex gap-2 m-2 items-center">
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.cor === '#ffffff' }"
							:style="{ backgroundColor: '#ffffff' }"
							@click="model.cor = '#ffffff'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.cor === '#ffff00' }"
							:style="{ backgroundColor: '#ffff00' }"
							@click="model.cor = '#ffff00'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.cor === '#008000' }"
							:style="{ backgroundColor: '#008000' }"
							@click="model.cor = '#008000'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.cor === '#ff0000' }"
							:style="{ backgroundColor: '#ff0000' }"
							@click="model.cor = '#ff0000'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.cor === '#0000ff' }"
							:style="{ backgroundColor: '#0000ff' }"
							@click="model.cor = '#0000ff'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.cor === '#800080' }"
							:style="{ backgroundColor: '#800080' }"
							@click="model.cor = '#800080'"
						/>
						<svg
							class="cursor-pointer text-[#464947]"
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							@click="setting_color = !setting_color"
						>
							<g
								fill="none"
								fill-rule="evenodd"
							>
								<path
									d="M24 0v24H0V0h24ZM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018Zm.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01l-.184-.092Z"
								/>
								<path
									fill="currentColor"
									d="M16 15c1.306 0 2.418.835 2.83 2H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 1 1 0-2h9.17A3.001 3.001 0 0 1 16 15Zm0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2ZM8 9a3 3 0 0 1 2.762 1.828l.067.172H20a1 1 0 0 1 .117 1.993L20 13h-9.17a3.001 3.001 0 0 1-5.592.172L5.17 13H4a1 1 0 0 1-.117-1.993L4 11h1.17A3.001 3.001 0 0 1 8 9Zm0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2Zm8-8c1.306 0 2.418.835 2.83 2H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 0 1 0-2h9.17A3.001 3.001 0 0 1 16 3Zm0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2Z"
								/>
							</g>
						</svg>
						<!-- <Icon class="flex gap-2 !w-[20px] !h-[20px] cursor-pointer" @click="setting_color = !setting_color" name="mingcute:settings-6-line"
                    color="#464947" :horizontalFlip="true" /> -->
					</div>
					<div
						v-if="setting_color"
						class="setting_color_new"
					>
						<div class="flex mb-[4px] w-fit flex-col">
							<span class="font-bold">HEX</span>
							<div class="flex items-center gap-1 border border-[#737576] rounded-[4px] px-2">
								<input
									id=""
									v-model="corModel"
									type="text"
									name=""
									class="w-[5.47vw] leading-7 outline-none"
								/>
								<input
									id="hex"
									v-model="corModel"
									type="color"
									class="cursor-pointer"
								/>
							</div>
						</div>
					</div>
					<div
						v-if="corFoiSugerida"
						class="flex items-center gap-2 border-2 rounded p-2 bg-[#C5CBF1] text-[#272728] border-[#6745ED]"
					>
						<i class="fas fa-info-circle text-xl text-[#6745ED]" />
						<p class="font-medium !m-0">
							{{ $t('corSugerida') }}
						</p>
					</div>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../../components/DownloadButton/DownloadButton";
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../../components/Pagination/Pagination'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	listarCategoriasDeFitossanidade,
	cadastrarCategoriaDeFitossanidade,
	atualizarCategoriaDeFitossanidade,
	excluirListaDeCategoriasDeFitossanidade,
} from '../../../../services/requests/CategoriaDeFitossanidadeRequests'

import validarCategoriaDeFitossanidade from '../../../../validations/CategoriaDeFitossanidadeValidation'
import { exportarCsv } from '../../../../utils/csvHellpers'
import { corDeterministicaDeCategoria } from '../../../../utils/coresDeCategoria'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		// Accordion,
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			setting_color: false,
			/**
			 * Indica que a cor exibida no formulário foi sugerida pelo sistema
			 * (registro ainda sem cor cadastrada) e será gravada ao salvar
			 */
			corFoiSugerida: false,
			intention: {},
			categoriaPadrao: [
				'PRAGAS E DOENÇAS',
				'FALTA DE ÁGUA',
				'EXCESSO DE ÁGUA',
				'ATAQUE DE FORMIGAS',
				'DERIVA DE HERBICIDA',
				'DEFICIÊNCIA NUTRICIONAL',
				'EXCESSO DE NUTRIENTES',
				'SAUDAVEL',
				'INDEFINIDA',
			],
			showExclusionAlert: false,
			headersSelecionados: ['codigo', 'nome', 'corExibicao'],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				codigo: '',
				nome: '',
				descricao: '',
				cor: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'CF',
				subtitleCardPropertie: 'nome',
				titleCardPropertie: 'codigo',
				colorIndicator: ['corExibicao'],
			},
			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{ key: 'nome', value: this.$t('name'), isActive: true },
				{ key: 'corExibicao', value: this.$t('color'), isActive: true },
			],
			desabilitarCamposDoFormularioParaCategoriasPadrao: false,
		}
	},
	computed: {
		corModel: {
			get() {
				return this.model.cor
			},
			set(value) {
				this.model.cor = value
			},
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.nome
		},

		/**
		 * Enriquece os itens da listagem com os dados de apresentação.
		 *
		 * A cor sugerida vai em `corExibicao`, nunca em `cor`: escrever no campo
		 * da entidade fazia o formulário de edição enviar ao backend uma cor que
		 * o usuário não escolheu.
		 *
		 * A mutação nos próprios itens é intencional: o CrudTable registra a
		 * seleção escrevendo `isCheckedToDelete` na linha que recebe, e
		 * `modelsIdWithCheckedToDelete` lê essa marcação a partir do `modelList`.
		 * Retornar cópias aqui quebraria a exclusão de registros.
		 */
		tableData() {
			this.modelsToBeShowedAndTotal.items.forEach((categoria) => {
				categoria.corExibicao = categoria.cor || corDeterministicaDeCategoria(categoria.nome)
				categoria.isBlocked = this.categoriaPadrao.includes(categoria.nome)
			})
			return this.modelsToBeShowedAndTotal.items
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['codigo']
		listarCategoriasDeFitossanidade().then((response) => {
			const { data: result } = response
			result.forEach((f) => (f.isCheckedToDelete = false))
			this.modelList = result
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		createCategoriaDeFitossanidadeToPost() {
			return {
				id: uuidv4(),
				nome: this.model.nome,
				descricao: this.model.descricao,
				cor: this.model.cor,
			}
		},

		downloadCSVCategoriaFitossanidade() {
			let cabecalhoDoCsvCategoriaFitossanidade = ['Código', 'Descrição', 'Nome', 'Cor ']
			const items = this.modelList

			const linhas = items.map((item) => [item.codigo, item.descricao, item.nome, item.cor])

			exportarCsv('export_categoria_fitossanidade', cabecalhoDoCsvCategoriaFitossanidade, linhas)
		},

		/**
		 * Cria novo Especie no banco de dados
		 */
		create() {
			const categoriaDeFitossanidade = this.createCategoriaDeFitossanidadeToPost()
			const { isValid, message } = validarCategoriaDeFitossanidade(
				categoriaDeFitossanidade,
				this.modelList,
			)

			if (isValid) {
				cadastrarCategoriaDeFitossanidade(categoriaDeFitossanidade)
					.then((response) => {
						const { data: categoriaDeFitossanidade } = response
						this.disableSaveButton = false

						this.cleanModel()
						categoriaDeFitossanidade.isCheckedToDelete = false
						this.modelList.unshift(categoriaDeFitossanidade)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					})
					.catch((err) => {
						this.disableSaveButton = false
						this.mutationShowMessage({
							messageTitle: 'Erro',
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
							messageText: err.response.data.errors.Mensagens[0],
						})
					})
			} else {
				this.disableSaveButton = false
				this.mutationShowMessage({
					messageTitle: 'Erro',
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
					messageText: message,
				})
			}
		},

		/**
		 * Cria o objeto que deve ser enviado para o backend na atualização,
		 * sem os campos que existem apenas para a apresentação na listagem.
		 */
		createCategoriaDeFitossanidadeToPut() {
			return {
				id: this.model.id,
				nome: this.model.nome,
				descricao: this.model.descricao,
				cor: this.model.cor,
			}
		},

		/**
		 * Atualiza categoria de fitossanidade no banco de dados
		 */
		update() {
			atualizarCategoriaDeFitossanidade(this.createCategoriaDeFitossanidadeToPut()).then(
				(response) => {
					const { data: model } = response
					this.disableSaveButton = false

					model.isCheckedToDelete = false

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)
					this.$set(this.modelList, indexModel, model)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				},
			)
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(especie) =>
						this.modelsIdWithCheckedToDelete.includes(especie.id) &&
						especie.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						excluirListaDeCategoriasDeFitossanidade(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var especiesOrganizadas = existeRegistroComDependencia
						.map(
							(especie) =>
								`• Especie: ${especie.espe_cd_codigo} / Plantio: ${especie.espe_ds_nome}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('materialGeneticoAtrelado')}:</b> <br/><br/> ${especiesOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			// Registros antigos podem não ter cor cadastrada. Pré-preenche o model
			// com a mesma cor sugerida que a listagem exibe, para que a cor vista
			// no formulário seja exatamente a que será gravada ao salvar.
			this.corFoiSugerida = !this.model.cor
			if (this.corFoiSugerida) {
				this.model.cor = corDeterministicaDeCategoria(this.model.nome)
			}

			if (this.categoriaPadrao.includes(this.model.nome))
				this.desabilitarCamposDoFormularioParaCategoriasPadrao = true
			else this.desabilitarCamposDoFormularioParaCategoriasPadrao = false

			this.titleForm = `${this.$t('edit')} ${this.$t('fitoCategory')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.desabilitarCamposDoFormularioParaCategoriasPadrao = false
			this.model.cor = '#008000'
			this.corFoiSugerida = false
			this.titleForm = `${this.$t('create')} ${this.$t('fitoCategory')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
<style scoped>
.ball {
	box-shadow: inset 2px 2px 4px rgba(30, 30, 30, 0.25);
}

.ball.active {
	border: 2px black solid;
}

#hex {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	border: none;
	background: none;
	border-radius: 50%;
	width: 1.5rem;
	height: 1.7rem;
}

#hex::-webkit-color-swatch {
	border-radius: 50%;
	border: 1px solid gray;
}

#hex::-moz-color-swatch {
	border-radius: 50%;
	border: none;
}
</style>
